import React, { PureComponent, ReactNode } from 'react';
import classes from './SampleComponent.module.scss';

interface ISampleComponentProps {
  // tslint:disable-next-line:no-any
  clicked?: (...args: any[]) => void;
  className?: string;
  children?: ReactNode;
}

export default class SampleComponent extends PureComponent<
  ISampleComponentProps
> {
  render() {
    return (
      <button
        className={classes.error}
        onClick={this.props.clicked}
        type="button"
      >
        {this.props.children}
      </button>
    );
  }
}
